import { Grid } from '@mui/material'
import { SavedSearchSelect } from './SavedSearch/SavedSearch'
import { SearchInput } from './SearchInput/SearchInput'
import { SpecialSearches } from './SearchInput/SpecialSearches'

export const SearchBar = () => {
  return (
    <Grid flexShrink={0} container spacing={0.5}>
      <Grid container size={{ xs: 12, sm: 'grow' }}>
        <Grid size="grow" flexWrap="nowrap">
          <SearchInput />
        </Grid>
        <Grid size="auto">
          <SpecialSearches />
        </Grid>
      </Grid>
      <Grid offset={{ md: 1 }} size={{ xs: 12, sm: 'grow' }} flexWrap="wrap">
        <SavedSearchSelect />
      </Grid>
    </Grid>
  )
}
